import styled from 'styled-components'

export const Label = styled.span<{ isLabelBold?: boolean }>`
  display: block;
  font-weight: ${props =>
    props.isLabelBold
      ? props.theme.font.weights.semiBold
      : props.theme.font.weights.regular};
  font-size: ${props => props.theme.font.sizes.medium};
  text-align: left;
`
export const LabelTooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
`

export const TooltipWrapper = styled.div`
  padding-left: ${props => props.theme.mp.xs};
  display: inline-block;
`
